// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a{text-decoration:none}.cursor-pointer{cursor:pointer}#app .primary--text,#app .v-btn:not(.v-btn--outlined).accent,#app .v-btn:not(.v-btn--outlined).error,#app .v-btn:not(.v-btn--outlined).info,#app .v-btn:not(.v-btn--outlined).primary,#app .v-btn:not(.v-btn--outlined).success,#app .v-btn:not(.v-btn--outlined).warning{color:#000}#app .v-btn:not(.v-btn--outlined).secondary{color:#fff}#app .v-card__title.stripe{border-bottom:6px solid #ffc107}", ""]);
// Exports
module.exports = exports;
